import { QueryCache } from '@tanstack/react-query';
import { redactGraphqlRequestErrorForTelemetry } from 'components/api/graphqlRequestError';
import { captureError } from 'helpers/captureError';

export function createMarketplaceQueryCache(): QueryCache {
  return new QueryCache({
    onError: (error, query) => {
      const errorContext = query.meta?.['captureErrorContext'];
      if (typeof errorContext === 'string') {
        captureError(redactGraphqlRequestErrorForTelemetry(error), errorContext);
      }
    },
  });
}
